/* eslint-disable no-console */
import React from 'react'
import { Link } from 'react-router-dom'

import {
  ContentWrap,
  Title,
  OrderedList,
  ListItem,
  ListItemInner,
  CenterWrap,
  NameWrap,
  StatsWrap,
  PercentWrap,
  OtherUserWrap,
  InviteButton,
  Button,
  SecondaryButton,
  GetMoreWrap,
} from './styled'

import Layout from 'src/components/Layout/Layout'
import { LoadingBlock } from 'src/components/Loading'
import { getConnections } from 'src/api/connections/connections'
import {
  ConnectionsResponse,
  ConnectionStatus,
} from 'src/api/connections/types'
import { PhotoProgressBar } from 'src/components/PhotoProgressBar/PhotoProgressBar'
import { LEADER_BOARD_DETAIL } from 'src/constants/routes'
import { InviteModal } from 'src/components/InviteModal/InviteModal'
import { InviteIcon, SmileyFacesIcon } from 'src/components/Icons'
import { EmptyState } from 'src/components/EmptyState/EmptyState'

export const Leaderboard: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(true)
  const [connections, setConnections] = React.useState<ConnectionsResponse>()
  const [inviteModalOpen, setInviteModalOpen] = React.useState(false)

  const fetchConnections = React.useCallback(async () => {
    try {
      const data = await getConnections(ConnectionStatus.approved)
      setConnections(data)
    } catch (e) {
      console.error(e)
    }
    setIsLoading(false)
  }, [])

  const handleGetMore = React.useCallback(async () => {
    if (connections) {
      const nextPage = {
        skip: connections.data.length,
      }
      try {
        const nextPageConnections = await getConnections(
          ConnectionStatus.approved,
          nextPage
        )

        setConnections({
          ...nextPageConnections,
          data: connections.data.concat(nextPageConnections.data),
        })
      } catch (e) {
        console.error('unhandled error', e)
      }
    }
  }, [connections])

  React.useEffect(() => {
    fetchConnections()
  }, [fetchConnections])

  return (
    <Layout withInvite>
      <InviteModal
        isOpen={inviteModalOpen}
        onClose={() => setInviteModalOpen(false)}
      />
      <ContentWrap>
        <InviteButton onClick={() => setInviteModalOpen(true)}>
          <InviteIcon />
        </InviteButton>
        <Title>Leaderboard</Title>
        {isLoading ? (
          <LoadingBlock />
        ) : connections && connections.data.length > 0 ? (
          <>
            <OrderedList>
              {connections?.data.map(({ id, otherUser, matchPercent }) => (
                <ListItem key={id}>
                  <Link
                    to={`${LEADER_BOARD_DETAIL.replace(':id', String(id))}`}
                  >
                    <ListItemInner>
                      <OtherUserWrap>
                        <div>
                          <PhotoProgressBar
                            uniqueIdentifier={id}
                            progress={
                              matchPercent && matchPercent > 0 ? 100 : 0
                            }
                            imgUrl={otherUser.profilePicture}
                          />
                        </div>
                        <CenterWrap>
                          <NameWrap>{otherUser.firstName}</NameWrap>
                          <StatsWrap>
                            {otherUser.completedQuizzesCount} quizzes completed
                          </StatsWrap>
                        </CenterWrap>
                      </OtherUserWrap>
                      <PercentWrap>
                        {matchPercent ? `${matchPercent}%` : '-'}
                      </PercentWrap>
                    </ListItemInner>
                  </Link>
                </ListItem>
              ))}
            </OrderedList>
            {connections.data.length < connections.total && (
              <GetMoreWrap>
                <SecondaryButton onClick={handleGetMore}>
                  Load more
                </SecondaryButton>
              </GetMoreWrap>
            )}
          </>
        ) : (
          <EmptyState
            icon={SmileyFacesIcon}
            title="No friends yet"
            body="Invite your friends and compare your results!"
            footer={() => (
              <Button onClick={() => setInviteModalOpen(true)}>
                Invite now
              </Button>
            )}
          />
        )}
      </ContentWrap>
    </Layout>
  )
}
